import PxsCountdownTimer from '@pixelunion/pxs-countdown-timer';
import ProductThumbnail from '../components/ProductThumbnail';

export default class CountdownTimer {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;
    this.product = this.el.querySelector('[data-product-thumbnail]');
    new PxsCountdownTimer(this.el);

    if (this.product) {
      const thumbnailSettings = {
        showSecondaryMediaOnHover: this.settings.show_secondary_media,
      };

      this.productThumbnail = new ProductThumbnail(this.product, thumbnailSettings);
    }
  }

  onSectionUnload() {
    if (this.product) this.productThumbnail.unload();
  }
}
